import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalDadosExtra",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "modalDadosExtra",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "modalDadosExtra"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = ["innerHTML"]

import { DadosExtraPackageRevisionDetailView } from "@/models/CardapioModel";
import { PropType, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DadosExtra',
  props: {
  dadosExtra: {
    type: Object as PropType<DadosExtraPackageRevisionDetailView | null>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const dadosExtra = ref<DadosExtraPackageRevisionDetailView | null>(props.dadosExtra);

watch(
  () => props.dadosExtra,
  (newValue) => {
    dadosExtra.value = newValue;
  },
  { immediate: true, deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(dadosExtra.value?.nomePersonalizacao), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              innerHTML: dadosExtra.value?.descricao
            }, null, 8, _hoisted_8)
          ])
        ])
      ])
    ])
  ]))
}
}

})